import {
  createSentryConfig,
  shouldCreateSpanForRequest
} from "@9amhealth/shared";
import { reactRouterV6BrowserTracingIntegration } from "@sentry/react";
import { Capacitor } from "@capacitor/core";
import { useEffect } from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes
} from "react-router-dom";
import envVariables from "./envVariables";

export const sentryConfig = createSentryConfig({
  dsn: envVariables.SENTRY_DSN,
  environment: envVariables.ENV_NAME,
  enabled: envVariables.PROD,
  release: `9am-${envVariables.APP_ENV}@${envVariables.BUILD_VERSION}`,
  enableLogs: true,
  integrations: [
    reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
      shouldCreateSpanForRequest,
      enableLongTask: false,
      enableInp: false,
      enableHTTPTimings: false
    })
  ],
  initialScope: {
    contexts: {
      app: {
        APP_ENV: envVariables.APP_ENV,
        ENV_NAME: envVariables.ENV_NAME,
        BUILD_VERSION: envVariables.BUILD_VERSION,
        platform: Capacitor.getPlatform()
      }
    }
  },
  ignoreErrors: [
    // Third-party loading failures
    "Failed to load Stripe.js",
    "Customer.io message error",
    // App update / version checks
    "No new version available",
    "no_new_version_available",
    // Auth / token lifecycle — expected in normal flows
    "No refresh token",
    // Biometric / native flows
    "Biometric verification failed",
    "disable_auto_update_under_native",
    // Push notifications registration — iOS fires this as a non-fatal event
    "capacitorDidRegisterForRemoteNotifications",
    // Data-not-found conditions covered by ignoreNineAmHealthErrorCodes
    /^Consistency score not found/,
    /^Default address not found/,
    // OTA / archive download failures (dev environment)
    /Failed to download from: https:\/\/app-archive.dev.join9am.com(.*)/,
    // Long-running loading state warnings (UUID suffix or named e.g. "avatar")
    /^Long-running loading state:/,
    // mixpanel-browser IndexedDB init bug on Safari (no user impact)
    /evaluating '[\w$]+\.objectStoreNames'/
  ]
});
